

export default function reducer(state={
    data: [],
    navigation: [],
    loading: true,
    loaded: false,
    pageLoading: true,
    pageLoaded: false,
    error: null,
  }, action) {

    switch (action.type) {

      case "GETTING_NAV": {
          return {...state, loading: true }
      }
      case "GOT_NAV": {
        return {
          ...state,
          loading: false,
          loaded: true,
          navigation: action.payload,
        }
      }
      default: {
        return {
          ...state
        };
      }
    }
}




// WEBPACK FOOTER //
// ./src/js/redux/reducers/Navigation.js